const locales = ["de", "en"];
const defaultLocale = "de";

module.exports = { locales, defaultLocale };
